import { Text } from '@billy/design-system'

import * as Styled from './styles'

interface SelectedVatProps {
  value: string
}

export const SelectedVat = ({ value }: SelectedVatProps) => {
  return (
    <Styled.SelectedVat>
      <Text colorVariant="secondary" truncate>
        {value}
      </Text>
    </Styled.SelectedVat>
  )
}
